import { useState, useEffect } from 'react';
import { Dashboard } from './components/Dashboard';
import { getStatus, startProducer, startAudio, stopAll, type Status, type LogEntry } from './lib/api';
import { socketClient } from './lib/socket';

function App() {
  const [status, setStatus] = useState<Status>({
    producer: { status: 'idle', total: 49, completed: 0, progress: 0, lastUpdate: null },
    audio: { status: 'idle', total: 49, completed: 0, progress: 0, lastUpdate: null },
    topics: []
  });
  const [logs, setLogs] = useState<LogEntry[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  // 初始加载状态
  useEffect(() => {
    loadStatus();
    socketClient.connect();

    socketClient.on('status', (newStatus: Status) => {
      setStatus(newStatus);
    });

    socketClient.on('log', (log: LogEntry) => {
      setLogs(prev => [...prev.slice(-99), log]);
    });

    return () => {
      socketClient.disconnect();
    };
  }, []);

  const loadStatus = async () => {
    try {
      const data = await getStatus();
      setStatus(data);
    } catch (error) {
      console.error('加载状态失败:', error);
    }
  };

  const handleStartProducer = async () => {
    setIsLoading(true);
    try {
      await startProducer();
      setLogs(prev => [...prev, {
        type: 'info',
        message: '脚本生成任务已启动',
        timestamp: new Date().toISOString()
      }]);
    } catch (error: any) {
      setLogs(prev => [...prev, {
        type: 'error',
        message: `启动失败: ${error.message}`,
        timestamp: new Date().toISOString()
      }]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleStartAudio = async () => {
    setIsLoading(true);
    try {
      await startAudio();
      setLogs(prev => [...prev, {
        type: 'info',
        message: '音频生成任务已启动',
        timestamp: new Date().toISOString()
      }]);
    } catch (error: any) {
      setLogs(prev => [...prev, {
        type: 'error',
        message: `启动失败: ${error.message}`,
        timestamp: new Date().toISOString()
      }]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleStopAll = async () => {
    setIsLoading(true);
    try {
      await stopAll();
      setLogs(prev => [...prev, {
        type: 'info',
        message: '所有任务已停止',
        timestamp: new Date().toISOString()
      }]);
    } catch (error: any) {
      setLogs(prev => [...prev, {
        type: 'error',
        message: `停止失败: ${error.message}`,
        timestamp: new Date().toISOString()
      }]);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dashboard
      status={status}
      logs={logs}
      onStartProducer={handleStartProducer}
      onStartAudio={handleStartAudio}
      onStopAll={handleStopAll}
      isLoading={isLoading}
    />
  );
}

export default App;
